import React from 'react';
import { styles } from './Legals.css';
import { NavItem } from '../types';
import { Link } from '../../PlatformFunctionality';

export type LegalsProps = {
  legalsLinks?: Array<NavItem>;
  copyrightYear?: string;
};

export const Legals = ({ legalsLinks, copyrightYear }: LegalsProps) => {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <div className={styles.container}>
      <div className={styles.copyrightBlock}>
        <span>
          ©{copyrightYear || year} <Link href={'/'}>JB Hi-Fi </Link>All rights reserved
        </span>
      </div>
      <div className={styles.legalsContent}>
        {legalsLinks?.length ? (
          <ul className={styles.legalsList}>
            {legalsLinks.map(link => {
              return (
                <li key={link.url} className={styles.navItem}>
                  <Link href={link.url}>{link.label}</Link>
                </li>
              );
            })}
          </ul>
        ) : null}
      </div>
    </div>
  );
};
